import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Layers } from 'lucide-react';
import { useReadingTabs } from '@/hooks/useReadingTabs';
import ReadingTabsBottomSheet from '@/components/reading-tabs/ReadingTabsBottomSheet';

/** Na leitura (mobile): FAB + folha das abas — a barra inferior do capítulo fica no centro; este botão à esquerda. */
export default function ReadingTabsMobileChapterTrigger() {
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);
    const tabs = useReadingTabs();
    const m = pathname.match(/^\/capitulo\/(\d+)/);
    const activeCapId = m?.[1] != null ? Number(m[1]) : null;

    return (
        <>
            <button
                type="button"
                className="lg:hidden fixed left-4 z-[95] flex h-12 w-12 items-center justify-center rounded-full border border-white/15 bg-black/85 text-white/90 shadow-xl backdrop-blur-md bottom-[calc(6.25rem+env(safe-area-inset-bottom))] active:scale-95"
                aria-label="Abas de leitura"
                onClick={() => setOpen(true)}
            >
                <Layers size={22} strokeWidth={2} />
            </button>
            <ReadingTabsBottomSheet
                open={open}
                onClose={() => setOpen(false)}
                tabs={tabs}
                activeCapId={activeCapId != null && Number.isFinite(activeCapId) ? activeCapId : null}
            />
        </>
    );
}
